import { render } from "./Idle.vue?vue&type=template&id=8467f1d4"
import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"

import "./Idle.vue?vue&type=style&index=0&id=8467f1d4&lang=scss"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__